import { Button, Modal } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

export type MailboxRequiredMode = 'connect' | 'reconnect';

export type MailboxRequiredDialogProps = {
  readonly mode: MailboxRequiredMode | null;
  readonly canConnect: boolean;
  readonly onClose: () => void;
  readonly onConnect: () => void;
};

export function MailboxRequiredDialog({ mode, canConnect, onClose, onConnect }: MailboxRequiredDialogProps) {
  const surfaceT = useTranslations('pages.workspace.mailboxSurface');
  const t = useTranslations('pages.workspace.emailAddress');

  const copy =
    mode === 'reconnect'
      ? {
          heading: surfaceT('reconnect-heading'),
          body: surfaceT('reconnect-body'),
          cta: surfaceT('reconnect-cta'),
        }
      : {
          heading: surfaceT('connect-heading'),
          body: t('connect-body'),
          cta: surfaceT('connect-cta'),
        };

  return (
    <Modal
      open={mode !== null}
      onClose={onClose}
      size="sm"
      dirty={false}
      title={copy.heading}
      footer={
        <>
          <Button variant="ghost" type="button" onClick={onClose}>
            {t('cancel')}
          </Button>
          {canConnect && (
            <Button variant="primary" type="button" onClick={onConnect}>
              {copy.cta}
            </Button>
          )}
        </>
      }
    >
      <p className="text-base-sm text-text-secondary">{copy.body}</p>
    </Modal>
  );
}
